/**
 * Flowlytics Pixel SDK - Main Entry Point
 * Version: see package.json (injected at build time as __SDK_VERSION__)
 * Read-Only Architecture - Non-Invasive Cross-Platform Tracking
 */

import FlowlyticsClass from "./core/init";

// Auto-initialize if config is provided via global variable
// Support both flowlyticsConfig (lowercase) and FlowlyticsConfig (uppercase) for compatibility
if (typeof window !== "undefined") {
  const config = window.flowlyticsConfig || window.FlowlyticsConfig;
  if (config) {
    const flowlytics = new FlowlyticsClass(config);

    // Expose to global scope immediately
    window.flowlytics = flowlytics;

    // Initialize asynchronously with error handling
    flowlytics
      .init()
      .then(() => {
        if (config.debug) {
          console.log("[Flowlytics] Auto-initialization complete");
        }
      })
      .catch((error) => {
        console.error("[Flowlytics] Auto-initialization failed:", error);
      });
  }
}

// Export directly (not as default) for UMD compatibility
export { FlowlyticsClass as default };

// This ensures window.Flowlytics is the class itself, not wrapped
if (typeof window !== "undefined") {
  window.Flowlytics = FlowlyticsClass;
}
